import React, { useState, useEffect } from "react";
import SharesDataService from "../services/SharesService";

const Shares = props => {
  const initialSharesState = {
    amount: "",
    previousBalance: "",
    newBalance: ""
  };
  const [currentShares, setCurrentShares] = useState(initialSharesState);
  const [message, setMessage] = useState("");

  const getShares = id => {
    SharesDataService.get(id)
      .then(response => {
        setCurrentShares(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getShares(props.match.params.id);
  }, [props.match.params.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentShares({ ...currentShares, [name]: value });
  };

  const updateShares = () => {
    SharesDataService.update(currentShares.id, currentShares)
      .then(response => {
        console.log(response.data);
        setMessage("Shares transactions was updated successfully!");
      })
      .catch(e => {
        console.log(e);
      });
  };

  const deleteShares = () => {
    SharesDataService.remove(currentShares.id)
      .then(response => {
        console.log(response.data);
        props.history.push("/shares");
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentShares ? (
        <div className="edit-form">
          <h4>Shares Transactions</h4>
          <form>
            <div className="form-group">
              <label htmlFor="amount">Amount</label>
              <input
                type="text"
                className="form-control"
                id="amount"
                name="amount"
                value={currentShares.amount}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="previousBalance">Previous Balance</label>
              <input
                type="text"
                className="form-control"
                id="previousBalance"
                name="previousBalance"
                value={currentShares.previousBalance}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newBalance">New Balance</label>
              <input
                type="text"
                className="form-control"
                id="newBalance"
                name="newBalance"
                value={currentShares.newBalance}
                onChange={handleInputChange}
              />
            </div>
          </form>      

          <button className="badge badge-danger mr-2" onClick={deleteShares}>
            Delete
          </button>

          <button
            type="submit"
            className="badge badge-success"
            onClick={updateShares}
          >
            Update
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          <p>Please click on a Shares Transaction...</p>
        </div>
      )}
    </div>
  );
};

export default Shares;
